import { styled, Button as TamaguiButton, GetProps } from 'tamagui'

export const Button = styled(TamaguiButton, {
  name: 'Button',
  fontFamily: '$body',
  fontWeight: '600',
  borderRadius: '$4',
  cursor: 'pointer',
  pressStyle: {
    scale: 0.98,
    opacity: 0.9,
  },
  animation: 'quick',

  variants: {
    variant: {
      primary: {
        backgroundColor: '$orangePrimary',
        color: '$textPrimary',
        borderWidth: 0,
        hoverStyle: {
          backgroundColor: '$orangeSecondary',
          scale: 1.02,
        },
      },
      secondary: {
        backgroundColor: 'transparent',
        color: '$textPrimary',
        borderWidth: 1,
        borderColor: '$orangePrimary',
        hoverStyle: {
          backgroundColor: '$orangePrimary',
          borderColor: '$orangePrimary',
        },
      },
      ghost: {
        backgroundColor: 'transparent',
        color: '$textSecondary',
        borderWidth: 0,
        hoverStyle: {
          color: '$textPrimary',
          backgroundColor: '$backgroundSecondary',
        },
      },
    },

    size: {
      sm: {
        minHeight: 36,
        paddingHorizontal: '$4',
        paddingVertical: '$2',
        fontSize: '$4',
      },
      md: {
        minHeight: 44,
        paddingHorizontal: '$6',
        paddingVertical: '$2',
        fontSize: '$5',
      },
      lg: {
        minHeight: 52,
        paddingHorizontal: '$8',
        paddingVertical: '$3',
        fontSize: '$6',
      },
      xl: {
        minHeight: 60,
        paddingHorizontal: '$10',
        paddingVertical: '$3',
        fontSize: '$6',
      },
    },

    fullWidth: {
      true: {
        width: '100%',
      },
    },
  } as const,

  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
})

export type ButtonProps = GetProps<typeof Button>
